import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { ReportData } from '../SuitabilityFlow';
import SelectFilesStep from './SelectFilesStep';
import { SettingsRow } from 'src/suitability-report/SettingsRow';

type SelectClientStepProps = StepProps<ReportData> & {
  footer?: React.ReactNode;
};

export default function SelectDocumentsStep(props: SelectClientStepProps) {
  const { data, setData } = props;

  return (
    <SelectFilesStep
      {...props}
      title={`Include the advice you're giving ${data.client?.firstName}`}
      description="Advice/recommendations, including no change in circumstances, can be taken from any written notes or recordings containing it (such as meeting notes, recordings, internal notes). Please confirm what should be included."
      hint="The information already uploaded to the client's profile, financial and cashflows areas will automatically be included, so no need to include fact finds or similar."
      selectedFileIds={props.data.selectedDocumentIds}
      setSelectedFileIds={selectedFileIds =>
        props.setData({ ...props.data, selectedDocumentIds: selectedFileIds })
      }
      footer={
        <SettingsRow
          title="Optimise readability of advice"
          description="Automatically optimises wording to reduce repetition, add helpful context from client data, and make the advice easier to read. If turned off, your full original text is kept."
          checked={props.data.enableLastReview}
          onChange={value => setData({ ...data, enableLastReview: value })}
        />
      }
    />
  );
}
